import { render, staticRenderFns } from "./CodeEditorField.vue?vue&type=template&id=56a6c29e"
import script from "./CodeEditorField.vue?vue&type=script&lang=js"
export * from "./CodeEditorField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports